export default __webpack_public_path__ + "static/media/victory.8710fbb2.png";